<template>
    <div class="ah-page staff-roles-page">
        <div class="page-header bottom-margin">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1>身份功能設定</h1>
                    </div>
                    <div class="actions">
                        <el-button type="highlight" @click="handleAddBtnClick">新增身份功能</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="ah-container">
            <div class="ah-panel">
                <div class="panel-body">
                    <div style="text-align: left;">
                        <avatar-tip label="身份的作用？" align="right">身份用來預先設定好不同的功能範本，讓相同職等的人可直接套用，也可逐一微調喔。</avatar-tip>
                    </div>
                    <el-table v-loading="isLoading" :data="datas" style="width: 100%" class="ah-el-data-table" empty-text="沒有資料">
                        <el-table-column label="#" type="index"></el-table-column>
                        <el-table-column prop="grP_NAM" label="名稱" width="200">
                            <template slot-scope="scope">
                                <div class="strong">{{ scope.row.grP_NAM }}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="count" label="人數" width="80">
                            <template slot-scope="scope">
                                {{ scope.row.staffAccounts.length }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="staffs" label="帳號">
                            <template slot-scope="scope">
                                <div class="">
                                    <span class="staff-label" v-for="staff in scope.row.staffAccounts" :key="staff.stF_SNO" @click="handleStaffClick(staff.stF_SNO)">{{ staff.stF_NAM }}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="" label="" width="100">
                            <template slot-scope="scope">
                                <el-button size="small" type="primary" plain @click="handleEditBtnClick(scope.row)" v-if="scope.row.sno != 1">編輯</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import AvatarTip from '@/components/ui/AvatarTip';

export default {
    name: 'staff-roles-page',
    components: {
        AvatarTip,
    },
    data() {
        return {
            isLoading: true,
            datas: [],
        };
    },
    created() {
        this.updateData();
    },
    methods: {
        updateData() {
            this.isLoading = true;
            this.$api({
                url: '/AccountManagement/GetRoleGroups',
                method: 'GET',
            })
                .then((resp) => {
                    this.datas = resp.data.list.filter((o) => o.grP_NO !== 'SA');
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        handleAddBtnClick() {
            this.$router.push({ name: 'staff-roles-add' });
        },

        handleEditBtnClick(item) {
            this.$router.push({ name: 'staff-roles-edit', query: { no: item.grP_NO } });
        },

        handleStaffClick(sno) {
            this.$router.push({ name: 'staff-edit', params: { sno } });
        },
    },
};
</script>
<style lang="scss" scoped="">
@import "@/assets/scss/vars.scss";

.staff-roles-page {
    .staff-label {
        display: inline-block;
        background-color: #eee;
        color: #666;
        padding: 3px 6px;
        margin: 3px;
        border-radius: 4px;
        cursor: pointer;

        &:hover {
            background-color: #e5e4f5;
            color: $main-color;
        }
    }
}
</style>
